exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1oF2O{font-size:.85em}._1X5xP,._2PoNH{color:#d1001f;border-color:#d1001f}._2tnMO{color:#18824d;border-color:#18824d}._2RfJI{padding:0 5px}", ""]);

// exports
exports.locals = {
	"small": "_1oF2O",
	"alert": "_2PoNH",
	"warning": "_1X5xP",
	"success": "_2tnMO",
	"message": "_2RfJI"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./node_modules/sass-loader/lib/loader.js??ref--2-rules-4!./src/components/Callout/Callout.css
// module id = 1302
// module chunks = 0 1 2 3 5